import React, {PropTypes} from 'react';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

class SalarySums extends React.Component {

  static propTypes = {
    sums: PropTypes.object.isRequired
  };

  render () {
    return (
      <tr>
        <td className='col-gross-sum'>
          <span>
            {Math.round(this.props.sums.gross)} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
        </td>
        <td className='col-tax-sum'>
          <span>
            {Math.round(this.props.sums.tax)} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
        </td>
        <td className='col-allowance-sum'>
          <span>
            {Math.round(this.props.sums.allowance)} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
        </td>
        <td className='col-travel-sum'>
          <span>
            {Math.round(this.props.sums.travel)} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
        </td>
        <td className='col-net-sum'>
          <span>
            {Math.round(this.props.sums.net)} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
        </td>
      </tr>
    );
  }

}

export default SalarySums;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/salaries/salary-sums.js
 **/